import skillsData from '../../../data/skills';
import Skill from './Skill';
import Reveal from '../../Reveal';
import SectionHeading from '../../SectionHeading';

const Skills = () => {
  return (
    <section className='px-5 py-20 md:px-10 lg:px-20' id='skills'>
      <SectionHeading number='02 — Stack' title='Skills' />

      <div className='max-w-[900px] mx-auto flex flex-col gap-12'>
        {skillsData.groups.map((group, groupIndex) => (
          <Reveal key={group.id} delay={groupIndex * 100}>
            <h3 className='font-mono text-ink/40 text-center text-xs font-medium tracking-[0.25em] uppercase mb-5'>
              {group.title}
            </h3>
            <div className='flex flex-wrap justify-center gap-3'>
              {group.items.map((item) => (
                <Skill key={item} title={item} />
              ))}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Skills;
